<div class="login-page">
  <section class="login-shell">
    <div class="brand-panel">
      <img src="assets/Gea_Logo_Blanco.png" alt="GEA" class="brand-logo" />
      <h1>Codex Engineering Hub</h1>
      <p class="brand-copy">
        @if (isCreateAdminMode) {
          Create the first administrator to unlock the workspace and finish the initial setup.
        } @else {
          Sign in to continue into the engineering workspace and the connected feature set.
        }
      </p>
    </div>

    <form class="login-card" [formGroup]="loginForm" (ngSubmit)="submit()">
      <div class="card-header">
        <span class="eyebrow">
          @if (isCheckingAdmin) {
            Checking access
          } @else if (isCreateAdminMode) {
            First-time setup
          } @else {
            Welcome back
          }
        </span>
        <h2>{{ isCreateAdminMode ? 'Create Admin' : 'Login' }}</h2>
        <p>
          @if (isCheckingAdmin) {
            Preparing the authentication flow.
          } @else if (isCreateAdminMode) {
            Enter the username and password for the first administrator account.
          } @else {
            Enter your username and password to open the application.
          }
        </p>
      </div>

      @if (isCreateAdminMode) {
        <div class="notice">
          No administrator exists yet. This account will be created as an active admin user.
        </div>
      }

      <label class="field">
        <span>User name</span>
        <input
          type="text"
          formControlName="userName"
          autocomplete="username"
          placeholder="{{ isCreateAdminMode ? 'Enter admin user name' : 'Enter user name' }}"
        />
        @if (hasError('userName')) {
          <small>Username is required.</small>
        }
      </label>

      <label class="field">
        <span>Password</span>
        <div class="input-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            [attr.autocomplete]="showPassword ? 'off' : (isCreateAdminMode ? 'new-password' : 'current-password')"
            placeholder="{{ isCreateAdminMode ? 'Set admin password' : 'Enter password' }}"
          />
          <button
            type="button"
            class="toggle-password"
            (click)="togglePasswordVisibility()"
            tabindex="-1"
            [title]="showPassword ? 'Hide password' : 'Show password'"
          >
            <i [class]="showPassword ? 'dx-icon-eyeopen' : 'dx-icon-eyeclose'"></i>
          </button>
        </div>
        @if (hasError('password')) {
          <small>Password is required (min 6 characters).</small>
        }
      </label>

      @if (errorMessage) {
        <div class="alert">{{ errorMessage }}</div>
      }

      @if (infoMessage) {
        <div class="info">{{ infoMessage }}</div>
      }

      <button type="submit" [disabled]="isSubmitting || isCheckingAdmin || loginForm.invalid">
        @if (isCheckingAdmin) {
          Preparing...
        } @else if (isSubmitting && isCreateAdminMode) {
          Creating admin...
        } @else if (isSubmitting) {
          Signing in...
        } @else if (isCreateAdminMode) {
          Create Admin
        } @else {
          Sign in
        }
      </button>

      @if (!isCreateAdminMode && !isCheckingAdmin) {
        <button type="button" class="secondary-button" (click)="goToChangePassword()" [disabled]="isSubmitting || !loginForm.get('userName')?.value">
          Change Password
        </button>
      }
    </form>
  </section>
</div>

